// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Rf3M","imageUploader":"EGiftCard_imageUploader__32IDw"};